module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share"
  }, [_c('div', {
    staticClass: "player-list",
    staticStyle: {
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "overflow": "auto",
      "position": "absolute"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(this.movie_title) + "\n        ")]), _vm._v(" "), (_vm.isNotExist) ? _c('div', {
    staticClass: "notexist",
    attrs: {
      "id": "notexist"
    }
  }, [_vm._v("\n            " + _vm._s("分享播放地址已停用或者过期！") + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isShow) ? _c('div', {
    staticClass: "player",
    attrs: {
      "id": "player"
    }
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "playerContainer"
  }, [_c('flash-swf', {
    attrs: {
      "attributes": _vm.playerAttr,
      "flashvars": _vm.flashVars
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2ef0946","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Share/Share.vue
// module id = 409
// module chunks = 0